import { render, staticRenderFns } from "./ProfilePageInvira.vue?vue&type=template&id=3c25ba26&"
import script from "./ProfilePageInvira.vue?vue&type=script&lang=js&"
export * from "./ProfilePageInvira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports